import React from 'react';

export default function LoadingGuard({
  isLoading, error, children, config,
}) {
  const cfg = config || {};
  const loadingMessage = cfg.loadingMessage || 'Загрузка...';

  if (error) return <div style={{ color: 'red', background: 'white' }}>{error}</div>;
  if (isLoading) return <div>{loadingMessage}</div>;
  return children;
}
